import {
  FETCH_USERS_REQUEST,
  FETCH_USERS_SUCCESS,
  FETCH_USERS_FAILURE,
  ADD_USER_SUCCESS,
  UPDATE_USER_SUCCESS,
  DELETE_USER_SUCCESS,
  SET_EDITING_USER,
  CLEAR_EDITING_USER
} from '../../../../types/masters/users/user/userTypes';

const initialState = {
  list: [],
  loading: false,
  error: null,
  editingUser: null,
};

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_USERS_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_USERS_SUCCESS:
      return { ...state, loading: false, list: action.payload };
    case FETCH_USERS_FAILURE:
      return { ...state, loading: false, error: action.error };
    case ADD_USER_SUCCESS:
      return { ...state, list: [...state.list, action.payload] };
    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        list: state.list.map(u => u.user_id === action.payload.user_id ? action.payload : u),
      };
    case DELETE_USER_SUCCESS:
      return {
        ...state,
        list: state.list.filter(u => u.user_id !== action.payload),
      };
    case SET_EDITING_USER:
      return { ...state, editingUser: action.payload };
    case CLEAR_EDITING_USER:
      return { ...state, editingUser: null };
    default:
      return state;
  }
}
